import { useApp } from 'context/app-context'

const LoadingUser = () => {
  const { navigationCollapsed } = useApp()
  return (
    <div className="mt-4 flex w-full border-t border-gray-400 pl-4">
      <div className="py-4">
        <div className="h-10 w-10 overflow-hidden rounded-full border-2 border-gray-400" />
      </div>
      {!navigationCollapsed && (
        <div className="flex w-full items-center py-3.5">
          <div className="flex-1 pl-2 text-left leading-5">
            <div className="w-full break-all font-semibold text-white">
              <div className="h-4 w-2/3 animate-pulse bg-gray-400" />
            </div>
            <div className="mt-1.5 w-full text-sm text-gray-200">
              <div className="h-3 w-1/2 animate-pulse bg-gray-400" />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default LoadingUser
